'use client';
import Image from 'next/image';

const speakers = [
  {
      name: "Faraj Abutalibov",
      designation: "Senior Advisor Middle East",
      company: "Stellar Development Foundation",
      imageSrc: "/images/speakers/faraj-abutalibov.webp",
      alt: "faraj-abutalibov",
    },
  
    {
      name: "Pranav Jyoti",
      designation: "General Partner",
      company: "MIRAI Capital Global",
      imageSrc: "/images/speakers/pranav-jyoti.webp",
      alt: "pranav-jyoti",
    },
  
    {
      name: "Mary Pedler",
      designation: "Founder",
      company: "INPUT Global",
      imageSrc: "/images/speakers/mary-pedler.webp",
      alt: "mary-pedler",
    },
  
    {
      name: "Elena Aster",
      designation: "Senior Partner, RNK.VC & Founder",
      company: "Skytyx",
      imageSrc: "/images/speakers/elena-aster.webp",
      alt: "elena-aster",
    },
  
    {
      name: "Anton Reshetov",
      designation: "Co-founder",
      company: "TheGarden | AI Salon Dubai",
      imageSrc: "/images/speakers/anton-reshetov.webp",
      alt: "anton-reshetov",
    },
  
  
  // end of past speaker 2025
  {
    name: "Aly Madhavji",
    designation: "Managing Partner",
    company: "Blockchain Founders Fund",
    imageSrc: "/images/speakers/aly.webp",
    alt: "Aly",
  },
  {
    name: "Vineet Budki",
    designation: " Partner & CEO",
    company: " Sigma Capital Limited",
    imageSrc: "/images/speakers/vineet.webp",
    alt: "Vineet",
  },
  {
    name: "Luchang Z",
    designation: "Founding Partner",
    company: "Arcanum Capital",
    imageSrc: "/images/speakers/luchang.webp",
    alt: "luchang",
  },
  {
    name: "Laura K. Inamedinova",
    designation: "Cheif Ecosystem Officer",
    company: "Gate ecosystem / GVC",
    imageSrc: "/images/speakers/laura.webp",
    alt: "Laura",
  },
   
];

const SpeakerSection = () => {
  return (
    <section data-component-id="src/app/SpeakerSection.jsx:80:4" data-component-path="src/app/SpeakerSection.jsx" data-component-line="80" data-component-file="SpeakerSection.jsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22speakers%22%2C%22className%22%3A%22w-full%20bg-%5Blinear-gradient(40deg%2C%23060606_0%25%2C%23000000_70%25%2C_%231B339E_100%25)%5D%20px-%5B20px%5D%20py-%5B40px%5D%22%7D" id='speakers'
      className="w-full bg-[linear-gradient(40deg,#060606_0%,#000000_70%,_#1B339E_100%)] px-[20px] py-[40px]"
    >
      <div data-component-id="src/app/SpeakerSection.jsx:83:6" data-component-path="src/app/SpeakerSection.jsx" data-component-line="83" data-component-file="SpeakerSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B1540px%5D%22%7D" className="w-full max-w-[1540px]">
        {/* Section Title */}
        <h2 data-component-id="src/app/SpeakerSection.jsx:85:8" data-component-path="src/app/SpeakerSection.jsx" data-component-line="85" data-component-file="SpeakerSection.jsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-3xl%20sm%3Atext-4xl%20mb-10%20lg%3Atext-5xl%20font-semibold%20text-center%20text-white%22%2C%22textContent%22%3A%22Past%20Speakers%22%7D" className="text-3xl sm:text-4xl mb-10 lg:text-5xl font-semibold text-center text-white">
             Past Speakers
            </h2>

        {/* Speaker List Box */}
        <div data-component-id="src/app/SpeakerSection.jsx:90:8" data-component-path="src/app/SpeakerSection.jsx" data-component-line="90" data-component-file="SpeakerSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20%20max-w-%5B1200px%5D%20mx-auto%22%7D" className="w-full  max-w-[1200px] mx-auto">
          {/* Mobile gap-5 and larger screens gap-2 */}
          <div data-component-id="src/app/SpeakerSection.jsx:92:10" data-component-path="src/app/SpeakerSection.jsx" data-component-line="92" data-component-file="SpeakerSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20sm%3Agrid-cols-2%20md%3Agrid-cols-3%20lg%3Agrid-cols-4%20gap-y-2%20sm%3Agap-y-6%20gap-x-2%20sm%3Agap-x-6%20place-items-center%22%7D" className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-y-2 sm:gap-y-6 gap-x-2 sm:gap-x-6 place-items-center">
            {speakers.map((speaker, index) => (
              <div data-component-id="src/app/SpeakerSection.jsx:94:14" data-component-path="src/app/SpeakerSection.jsx" data-component-line="94" data-component-file="SpeakerSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20items-center%22%7D" key={index} className="flex flex-col items-center">
                {/* Adjusted Image Container for smaller mobile sizes */}
                {/* <div className="w-[120px] h-[120px] sm:w-[250px] sm:h-[250px] relative mb-4">
                  <Image
                    src={speaker.imageSrc}
                    alt={speaker.alt}
                    width={300}
                    height={300}
                    objectFit="cover"
                  />
                </div> */}
                <div data-component-id="src/app/SpeakerSection.jsx:105:16" data-component-path="src/app/SpeakerSection.jsx" data-component-line="105" data-component-file="SpeakerSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20items-center%22%7D" key={index} className="flex flex-col items-center">
                  {/* Image Container */}
                  <div data-component-id="src/app/SpeakerSection.jsx:107:18" data-component-path="src/app/SpeakerSection.jsx" data-component-line="107" data-component-file="SpeakerSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-%5B120px%5D%20h-%5B120px%5D%20sm%3Aw-%5B250px%5D%20sm%3Ah-%5B250px%5D%20relative%20mb-4%20rounded-full%20overflow-hidden%22%7D" className="w-[120px] h-[120px] sm:w-[250px] sm:h-[250px] relative mb-4 rounded-full overflow-hidden">
                    <Image data-component-id="src/app/SpeakerSection.jsx:108:20" data-component-path="src/app/SpeakerSection.jsx" data-component-line="108" data-component-file="SpeakerSection.jsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22object-cover%20w-full%20h-full%22%7D"
                      src={speaker.imageSrc}
                      alt={speaker.alt}
                      unoptimized
                      height={200}
                      width={200}
                      className="object-cover w-full h-full"
                    />
                  </div>
                </div>
                <h3 data-component-id="src/app/SpeakerSection.jsx:118:16" data-component-path="src/app/SpeakerSection.jsx" data-component-line="118" data-component-file="SpeakerSection.jsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-%5B%23fff%5D%20text-%5B13px%5D%20sm%3Atext-%5B18px%5D%20font-semibold%20text-center%20mb-1%22%7D" className="text-[#fff] text-[13px] sm:text-[18px] font-semibold text-center mb-1">
                  {speaker.name}
                </h3>
                <p data-component-id="src/app/SpeakerSection.jsx:121:16" data-component-path="src/app/SpeakerSection.jsx" data-component-line="121" data-component-file="SpeakerSection.jsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-white%20text-%5B12px%5D%20sm%3Atext-%5B14px%5D%20text-center%20mb-1%22%7D" className="text-white text-[12px] sm:text-[14px] text-center mb-1">
                  {speaker.designation}
                </p>
                <p data-component-id="src/app/SpeakerSection.jsx:124:16" data-component-path="src/app/SpeakerSection.jsx" data-component-line="124" data-component-file="SpeakerSection.jsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-white%20text-%5B10px%5D%20sm%3Atext-%5B12px%5D%20text-center%22%7D" className="text-white text-[10px] sm:text-[12px] text-center">
                  {speaker.company}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpeakerSection;
